<template>
  <div class="searching-supplier">
    <div class="searching-supplier__indicator">
      <ALottieAnimation width="200" height="200" path="assets/images/SearchingDriver.json" />
    </div>
    <div class="searching-supplier__desc" data-test-id="searchingSupplierDesc">{{ label }}</div>
  </div>
</template>

<script>
const ALottieAnimation = () => import('@/components/ahamove/ALottieAnimation')

export default {
  name: 'SearchingSupplier',
  components: {
    ALottieAnimation
  },
  props: {
    label: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.searching-supplier {
  min-height: 120px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  .searching-supplier__indicator {
    position: relative;
    max-height: 54px;

    > div {
      position: absolute;
      top: -86px;
      left: -100px;
    }
  }

  .searching-supplier__desc {
    position: absolute;
    bottom: 26px;
    color: #1a1a1a;
    font-size: 16px;
    font-weight: 500;
  }
}
</style>
